import axios from "axios";
import { unoStore } from "@simulanisindia/ui";


const apiclient = axios.create({
    headers: {
        "Content-Type": "application/json"
    }
});

const successResponseInterceptor = (response) => {
    return response?.data?.data;
};

const errorResponseInterceptor = (error) => {
    throw error
};


const requestInterceptor = (req) => {
    const state = unoStore.getState();
    const userData = state.user;
    req.headers.Authorization = `Bearer ${userData.token}`;
    return req;
}

apiclient.interceptors.request.use(requestInterceptor);
apiclient.interceptors.response.use(successResponseInterceptor, errorResponseInterceptor);

export default apiclient;